<template>
  <div class="sf-commcard sf-commcard-checks sf-below-3" type="checklist">
    <div class="sf-commcard-title sf-uppercase">{{ text }}</div>
    <div>
      <check-card
        v-for="check in sortedPendingChecks"
        :key="check.id"
        :allow-any-user="allowAnyUser"
        :open-reply="openReply"
        :show-context-btn="showContextBtn"
        v-bind="check"
        :default-comments-visibility-state="defaultCommentsVisibilityState"
        :show-period="showPeriod"
      ></check-card>
    </div>
    <div v-show="sortedCompletedChecks.length">
      <div class="sf-commcard-footer">
        <a @click="toggleCompletedChecks">{{
          I18n.t(
            'communication.checks.toggle_completed.' + showingCompletedChecks,
            { count: sortedCompletedChecks.length }
          )
        }}</a>
      </div>
    </div>
    <div v-show="showingCompletedChecks">
      <check-card
        v-for="check in sortedCompletedChecks"
        :key="check.id"
        :allow-any-user="allowAnyUser"
        :open-reply="openReply"
        :show-context-btn="showContextBtn"
        v-bind="check"
        :default-comments-visibility-state="defaultCommentsVisibilityState"
        :show-period="showPeriod"
      ></check-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapGetters, mapState } from 'vuex'

import checkHelpers from '../mixins/check-helpers'

import CheckCard from './check-card'

export default {
  mixins: [checkHelpers],
  props: {
    id: {
      type: Number,
      required: true,
    },
    ledgerId: {
      type: Number,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    participantIds: {
      type: Array,
      required: true,
    },
    defaultCommentsVisibilityState: {
      type: String,
      default: 'default',
    },
    showPeriod: {
      type: Boolean,
      default: false,
    },
    allowAnyUser: {
      type: Boolean,
      default: false,
    },
    showContextBtn: {
      type: Boolean,
      default: false,
    },
    openReply: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapActions(['toggleCompletedChecksInCheckList']),

    toggleCompletedChecks() {
      this.toggleCompletedChecksInCheckList(this.id)
    },
  },

  computed: {
    ...mapState({
      showingCompletedChecksInCheckListIds: (state) =>
        state.ui.showingCompletedChecksInCheckListIds,
      storeLedgerId: (state) => state.ledgerId,
    }),

    ...mapGetters(['checkListChecks']),

    checkIds() {
      return this.checkListChecks(this.ledgerId, this.id).map(
        (check) => check.id
      )
    },

    completedCheckIds() {
      return this.sortedCompletedChecks.map((check) => check.id)
    },

    sortedChecks() {
      return _.orderBy(
        this.checkListChecks(this.storeLedgerId || this.ledgerId, this.id),
        ['createdAt'],
        ['asc']
      )
    },

    sortedCompletedChecks() {
      return this.sortedChecks.filter((check) =>
        this.checkCheckedByAllParticipants(check)
      )
    },

    sortedPendingChecks() {
      return _.without(this.sortedChecks, ...this.sortedCompletedChecks)
    },

    showingCompletedChecks() {
      return this.showingCompletedChecksInCheckListIds.includes(this.id)
    },
  },

  components: {
    CheckCard,
  },
}
</script>
